/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 受付検索情報
 */

export interface Sgkb575aReqAceptSearchInfoDto {
    /** 
     * 受付番号：半角数字
     */
    aceptNo: String;
    /** 
     * 導管事業者申請受付番号：半角数字
     */
    doknjgyshAppAcceptancenumber: String;
    /** 
     * 受付履歴表示フラグ：真偽値
     */
    acceptancerirekiHyojiFlg: boolean;
}
